import { colors } from '../../colors';
var pencilBanner = {
  bgColor: colors.paleGrey,
  textColor: colors.dirtyBlue,
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default pencilBanner;